import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getContenidoLegalPublicoBySlug } from "../../services/public/legalPublic";
import "./PaginaDocumentosLegales.css";

function isLikelyHtml(s) {
  return /<\/?[a-z][\s\S]*>/i.test(String(s || ""));
}

function LegalDocumentPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      setError(null);
      setDoc(null);
      try {
        const data = await getContenidoLegalPublicoBySlug(slug);
        if (!cancelled) setDoc(data);
      } catch (e) {
        if (!cancelled) setError(e?.message || "No se pudo cargar el documento.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) {
    return (
      <div className="terms-page">
        <div className="terms-page__container">
          <p className="terms-page__intro">Cargando…</p>
        </div>
      </div>
    );
  }

  if (error || !doc) {
    return (
      <div className="terms-page">
        <div className="terms-page__container">
          <div className="terms-page__card">
            <p className="terms-page__intro">{error || "Documento no disponible."}</p>
            <div className="terms-page__actions">
              <button
                type="button"
                className="terms-page__back-btn"
                onClick={() => navigate(-1)}
              >
                Volver
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const body = doc.contenido ?? "";

  return (
    <div className="terms-page">
      <div className="terms-page__bg" aria-hidden="true" />

      <div className="terms-page__container">
        <div className="terms-page__card">
          <div className="terms-page__header">
            <span className="terms-page__eyebrow">Información legal</span>
            <h1 className="terms-page__title">{doc.titulo || "Documento"}</h1>
          </div>

          {isLikelyHtml(body) ? (
            <div
              className="terms-page__content terms-page__content--html"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          ) : (
            <div className="terms-page__content" style={{ whiteSpace: "pre-wrap" }}>
              {body}
            </div>
          )}

          <div className="terms-page__actions">
            <button
              type="button"
              className="terms-page__back-btn"
              onClick={() => navigate(-1)}
            >
              Volver
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LegalDocumentPage;
